import dayjs from 'dayjs';
import { tools as factoryTools } from 'tods-competition-factory';

export function renderTimeRange(a) {
  const date = dayjs().format('YYYY-MM-DD');
  const from = dayjs(`${date} ${a.from}`).format('hh:mm a');
  const to = dayjs(`${date} ${a.to}`).format('hh:mm a');
  return `${from} - ${to}`;
}

export function formatMatchUpScheduledTime({ matchUp }) {
  // matchUp.schedule.scheduledTime can be either a simple string "08:00" or a date string with time "2100-01-01T0800"
  // extractTime will return only the simple string
  const scheduledTimeString = factoryTools.dateTime.extractTime(matchUp?.schedule?.scheduledTime);

  // in this case we don't care what the date is since moment is being used to format the time string
  const date = new Date().toISOString().split('T')[0];
  const formattedTime = scheduledTimeString && dayjs(`${date}T${scheduledTimeString}`).format('hh:mm a');
  return formattedTime || 'N/A';
}

export function getScheduledTimeString(schedule) {
  return factoryTools.dateTime.extractTime(schedule?.scheduledTime || '');
}

export function getScheduledAt({ matchUp }) {
  const momentTime = getMomentTime({ matchUp });
  const isValid = momentTime && momentTime.isValid();
  return isValid && momentTime.toDate();
}

function getMomentTime({ matchUp }) {
  const time = factoryTools.dateTime.extractTime(matchUp?.schedule?.scheduledTime);
  const timeDate = factoryTools.dateTime.extractDate(matchUp?.schedule?.scheduledTime);
  const date =
    factoryTools.dateTime.extractDate(matchUp?.schedule?.scheduledDate) || timeDate || matchUp?.schedule?.scheduledDate;
  const dateAndTime = (date || time) && `${date ?? ''} ${time ?? ''}`;
  return dateAndTime && dayjs(dateAndTime);
}
